import { api, CASES_LIST_TAG } from '@/api';
import { setCasesList, type RootState } from '@/store';
import { handleQueryLifecycle } from '@/api/utils';

export interface BulkDeleteMattersRequest {
  csvString: string;
}

export interface BulkDeleteMattersResponse {
  matterIds: string[];
}

const bulkDeleteMattersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    bulkDeleteMatters: builder.mutation<BulkDeleteMattersResponse, BulkDeleteMattersRequest>({
      // `csvString` is read from the query string — the endpoint ignores a JSON
      // body and rejects the request as missing the field.
      query: ({ csvString }) => ({
        url: 'matters/bulk-delete',
        method: 'POST',
        params: { csvString },
      }),
      invalidatesTags: () => [{ type: CASES_LIST_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        await handleQueryLifecycle(queryFulfilled, ({ matterIds }) => {
          const deletedIds = new Set(matterIds);
          const state = getState() as RootState;
          dispatch(setCasesList(state.cases.casesList.filter(({ matterId }) => !deletedIds.has(matterId))));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useBulkDeleteMattersMutation } = bulkDeleteMattersApi;
